export default "__VITE_ASSET__04481615__"